// validador letras
export const sizeValidator = (val, size) => {
    if (val.toString().length < size) {
        return {
            valid: false,
            message: `Campo deve conter ao menos ${size} caracteres`
        }
    }
    return {
        valid: true,
        message: ""
    }
}


export const requiredValidator = (value) => {
    let isValid = true
    if(value == null) isValid = false
    else if (value === undefined) isValid = false
    else if (typeof value === "string" && value.trim() === "") isValid = false
    return {
        valid:isValid,
        message: "Esse campo é obrigatório!"
    }
    
};
// Validador select
export const requiredSelectValidator = (value) => {
    return {
        valid: value !== "",
        message: "Por favor, selecione uma opção válida."
    }
    
};

// criar validador pra cep
export const cepValidator = (value) => {
    const validationObject = { valid: true, message: "" };
    const pureVal = value.replace(/[^0-9]+/g, "");
    if (pureVal.length !== 8) {
        validationObject.valid = false;
        validationObject.message = "CEP inválido";
    }
    return validationObject;
}

// criar validador email
export const mailValidator = (value) => {
    const validationObject = { valid: true, message: "" };

    const mailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (!mailRegex.test(value)) {
        validationObject.valid = false;
        validationObject.message = "Email inválido";
        return validationObject;
    }
    return validationObject;
};

// cpf
export const cpfValidator = (value) => {
    const validationObject = { valid: true, message: "CPF Inválido!" };
    const pureVal = value.replace(/[^0-9]+/g, "");
    if (pureVal.length < 11) {
        validationObject.valid = false;
        return validationObject;
    }
    const validationDigits = pureVal.slice(0, 9);
    const validatorDigits = pureVal.slice(9, 11);

    let checkOne = 0;
    let checkTwo = 0;
    for (let index = 1; index < validationDigits.split("").length + 1; index++) {
        try {
            checkOne += parseInt(validationDigits[index - 1]) * index;
            checkTwo += parseInt(validationDigits[index - 1]) * (index - 1);
        } catch {
            validationObject.valid = false;
            return validationObject;
        }
    }
    checkOne = checkOne % 11;
    if (checkOne === 10) checkOne = 0;
    try {
        if (checkOne > 11 || checkOne !== parseInt(validatorDigits[0])) {
            validationObject.valid = false;
            return validationObject;
        }
    } catch {
        validationObject.valid = false;
        return validationObject;
    }

    checkTwo += checkOne * 9;
    checkTwo = checkTwo % 11;
    if (checkOne === 10) checkOne = 0;
    try {
        if (checkTwo > 11 || checkTwo !== parseInt(validatorDigits[1])) {
            validationObject.valid = false;
            return validationObject;
        }
    } catch {
        validationObject.valid = false;
        return validationObject;
    }
    return validationObject;
};

// cnpj
export const cnpjValidator = (value) => {
    const validationObject = { valid: true, message: "CNPJ Inválido!" };
    const pureVal = value.replace(/[^0-9]+/g, "");

    // Verifica se o CNPJ tem 14 dígitos
    if (pureVal.length !== 14) {
        validationObject.valid = false;
        return validationObject;
    }

    const validationDigits = pureVal.slice(0, 12);
    const validatorDigits = pureVal.slice(12, 14);

    let checkOne = 0;
    let checkTwo = 0;

    const weightsOne = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    for (let i = 0; i < 12; i++) {
        checkOne += parseInt(validationDigits[i]) * weightsOne[i];
    }
    checkOne = checkOne % 11;
    if (checkOne < 2) {
        checkOne = 0;
    } else {
        checkOne = 11 - checkOne;
    }

    if (checkOne !== parseInt(validatorDigits[0])) {
        validationObject.valid = false;
        return validationObject;
    }

    const weightsTwo = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    for (let i = 0; i < 13; i++) {
        checkTwo += parseInt(pureVal[i]) * weightsTwo[i];
    }
    checkTwo = checkTwo % 11;
    if (checkTwo < 2) {
        checkTwo = 0;
    } else {
        checkTwo = 11 - checkTwo;
    }

    if (checkTwo !== parseInt(validatorDigits[1])) {
        validationObject.valid = false;
        return validationObject;
    }

    return validationObject;
};

export const validateRegulatorioForm = (formData) => {
    const errors = {};

    if (formData.natureza.length < 1) {
        errors.natureza = "Selecione pelo menos 1 opção.";
    }

    if (!formData.movimentacao) {
        errors.movimentacao = "Selecione uma opção.";
    }

    if (!formData.produtos.trim()) {
        errors.produtos = "Este campo é obrigatório.";
    }
    if (!formData.clientes.trim()) {
        errors.clientes = "Este campo é obrigatório.";
    }
    if (!formData.instituicoes.trim()) {
        errors.instituicoes = "Este campo é obrigatório.";
    }

    return errors;
};



export const documentValidator = (file) => {
    const validationObject = { valid: true, message: "" };
    
    if (file && !['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/x-pdf'].includes(file.type)) {
        validationObject.valid = false
        validationObject.message = "O arquivo deve ser uma imagem (PNG, JPEG, JPG) ou PDF.";
    }

    return validationObject;
};

// criar validador para RG
export const rgValidator = (value) => {
    const validationObject = { valid: true, message: "" };

    const pureVal = value.replace(/\D/g, '');

    if (pureVal.length !== 9) {
        validationObject.valid = false;
        validationObject.message = "RG deve ter 9 dígitos";
        return validationObject;
    }

    const numeros = pureVal.slice(0, 8);
    const digitoControle = parseInt(pureVal.charAt(8));

    const multiplicadores = [2, 3, 4, 5, 6, 7, 8, 9];

    let soma = 0;
    for (let i = 0; i < 8; i++) {
        soma += parseInt(numeros.charAt(i)) * multiplicadores[i];
    }

    soma += digitoControle * 100;

    const resto = soma % 11;

    if (resto !== 0) {
        validationObject.valid = false;
        validationObject.message = "RG inválido";
    }

    return validationObject;
}
